import { render, staticRenderFns } from "./InstituteCorporate.vue?vue&type=template&id=d9836cb2&"
import script from "./InstituteCorporate.vue?vue&type=script&lang=js&"
export * from "./InstituteCorporate.vue?vue&type=script&lang=js&"
import style0 from "./InstituteCorporate.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports